import type { ActionPolicy } from "../policy/ruleSchema.js";
import type { OrganizationEntitlements } from "./organizationEntitlements.js";

export const policyUsesApprovalGroups = (policy: ActionPolicy): boolean =>
  (policy.rules ?? []).some(
    (rule) => rule.approver_group_id !== undefined && rule.approver_group_id.length > 0
  );

/** Multi-rule conditional ladder (escalation) — more than one evaluated rule. */
export const policyUsesEscalationRules = (policy: ActionPolicy): boolean =>
  (policy.rules?.length ?? 0) > 1;

export const policyRequiredFeatureFlags = (
  policy: ActionPolicy
): Array<keyof OrganizationEntitlements> => {
  const keys: Array<keyof OrganizationEntitlements> = [];
  if (policyUsesApprovalGroups(policy)) {
    keys.push("feature_approval_groups");
  }
  if (policyUsesEscalationRules(policy)) {
    keys.push("feature_escalation_rules");
  }
  return keys;
};
